export enum LinkManagementGetters {
    GET_FORM_VALUES = 'GET_FORM_VALUES',
    GET_OPEN_INCIDENTS = 'GET_OPEN_INCIDENTS',
}
